// Banner "problema tehnica" afisat deasupra carusel-ului de pe prima pagina.
// Se activeaza/dezactiveaza din /apanel (doc Firestore appSettings/techIssueBanner -> { enabled: boolean }).
export const DEFAULT_TECH_ISSUE_BANNER_ENABLED = false;
